import {onFind} from "@elements/init-modules-in-scope";
import {removeClass,addClass,hasClass,on,findIn} from '@elements/dom-utils';
import {translate} from '@elements/translations';

const selectors = {
    base: '.js-edit-address',
    btn: '.js-edit-address__btn',
    saveBtn: '.js-save-address__btn',
    btnText: '.js-save-address__btn-text',
    cancelBtn: '.js-cancel-address__btn',
    infos: '.js-edit-address__infos',
    inputs: '.js-edit-address__inputs',
    companyInput: '.js-edit-address__company-input',
    nameInput: '.js-edit-address__name-input',
    firstNameInput: '.js-edit-address__firstname-input',
    lastNameInput: '.js-edit-address__lastname-input',
    streetInput: '.js-edit-address__street-input',
    plzInput: '.js-edit-address__plz-input',
    townInput: '.js-edit-address__town-input',
    countryInput: '.js-edit-address__country-input',
    company: '.js-edit-address__company',
    name: '.js-edit-address__name',
    firstName: '.js-edit-address__firstname',
    lastName: '.js-edit-address__lastname',
    street: '.js-edit-address__street',
    plz: '.js-edit-address__plz',
    town: '.js-edit-address__town',
    country: '.js-edit-address__country'
};

export function init() {
    onFind(selectors.base, function (baseElement) {
        let btn = findIn(selectors.btn, baseElement);
        let infos = findIn(selectors.infos, baseElement);
        let inputs = findIn(selectors.inputs, baseElement);
        let saveBtn = findIn(selectors.saveBtn, baseElement);
        let btnText = findIn(selectors.btnText, baseElement);
        let companyInput = findIn(selectors.companyInput, baseElement);
        let nameInput = findIn(selectors.nameInput, baseElement);
        let firstNameInput = findIn(selectors.firstNameInput, baseElement);
        let lastNameInput = findIn(selectors.lastNameInput, baseElement);
        let streetInput = findIn(selectors.streetInput, baseElement);
        let plzInput = findIn(selectors.plzInput, baseElement);
        let townInput = findIn(selectors.townInput, baseElement);
        let countryInput = findIn(selectors.countryInput, baseElement);
        let company = findIn(selectors.company, baseElement);
        let name = findIn(selectors.name, baseElement);
        let firstName = findIn(selectors.name, baseElement);
        let lastName = findIn(selectors.name, baseElement);
        let street = findIn(selectors.street, baseElement);
        let plz = findIn(selectors.plz, baseElement);
        let town = findIn(selectors.town, baseElement);
        let country = findIn(selectors.country, baseElement);

        on("click", function () {
            console.log("click edit btn")
            if (hasClass('inputs-hidden', btn)){
                removeClass('inputs-hidden', btn);
                infos.removeAttribute("hidden");
                inputs.setAttribute("hidden", true);
            }else {
                addClass('inputs-hidden', btn);
                inputs.removeAttribute("hidden");
                infos.setAttribute("hidden", true);
            }
        }, btn);


        on("click", function () {
            //check if saveBtn has attribute data-ajax-form
            //if yes, we trigger the submit event
            if (saveBtn.hasAttribute("data-ajax-form")) {
                infos.removeAttribute("hidden");
                inputs.setAttribute("hidden", true);
                removeClass('inputs-hidden', btn);
            } else {
                if (companyInput && companyInput.value === "" || nameInput && nameInput.value === "" || firstNameInput && firstNameInput.value === "" || lastNameInput && lastNameInput.value === "" || streetInput && streetInput.value === "" || plzInput && plzInput.value === "" || townInput && townInput.value === "") {
                    if(btnText) {
                        btnText.removeAttribute("hidden");
                        return;
                    }
                } else {
                    if(btnText) {
                        btnText.setAttribute("hidden", true);
                    }

                    infos.removeAttribute("hidden");
                    inputs.setAttribute("hidden", true);
                    removeClass('inputs-hidden', btn);

                    let countryText = "";
                    if (countryInput){
                        let countryOptions = countryInput.options;
                        for (let i = 0; i < countryOptions.length; i++) {
                            if (countryOptions[i].selected) {
                                countryText = countryOptions[i].text;
                                break;
                            }
                        }
                    }

                    if(company || name || firstName || lastName || street || plz || town || country){
                        if (company && companyInput){
                            company.innerHTML = companyInput.value;
                        }
                        if (name && nameInput){
                            name.innerHTML = nameInput.value;
                        }
                        if (firstName && firstNameInput){
                            firstName.innerHTML = firstNameInput.value;
                        }
                        if (lastName && lastNameInput){
                            lastName.innerHTML = lastNameInput.value;
                        }
                        if (street && streetInput){
                            street.innerHTML = streetInput.value;
                        }
                        if (plz && plzInput){
                            plz.innerHTML = plzInput.value;
                        }
                        if (town && townInput){
                            town.innerHTML = townInput.value;
                        }
                        if (country && countryInput){
                            country.innerHTML = countryText;
                        }
                    } else { // if no fields are present, we build the address string
                        let newAdressString  =
                            (companyInput ? companyInput.value + "<br>" : "") +
                            (nameInput ? nameInput.value + "<br>" : "") +
                            (firstNameInput ? firstNameInput.value + " " : "") +
                            (lastNameInput ? lastNameInput.value + "<br>" : "") +
                            (streetInput ? streetInput.value + "<br>" : "") +
                            (plzInput ? plzInput.value + " " : "") +
                            (townInput ? townInput.value + "<br>" : "") +
                            (countryText);
                        infos.innerHTML = newAdressString;
                    }
                }
            }
        }, saveBtn);
    });
}
